<template>
  <div class="page" :class="{ 'page__has-bar': executable }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">来访编号</label>
            <em class="weui-form-preview__value">{{ form.main.vi_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="vi_username">
            <label class="weui-form-preview__label">{{
              customLabel.vi_username || "来访人员"
            }}</label>
            <em class="weui-form-preview__value">{{
              form.main.vi_username
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="vi_mobile">
            <label class="weui-form-preview__label">{{
              customLabel.vi_username || "手机号"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">{{
              form.main.vi_mobile
            }}
              <call-mobile :mobile="form.main.vi_mobile"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.vi_job" slot="vi_job">
            <label class="weui-form-preview__label">{{
              customLabel.vi_job || "职务"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.vi_job
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="vi_corpname">
            <label class="weui-form-preview__label">{{
              customLabel.vi_corpname || "公司名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.vi_corpname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="vi_obj_name">
            <label class="weui-form-preview__label">{{
              customLabel.vi_obj_name || "拜访对象"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.vi_obj_name
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="identity">
            <label class="weui-form-preview__label">{{
              customLabel.identity || "合作身份"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.identity
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="createTime">
            <label class="weui-form-preview__label">{{
              customLabel.createTime || "申请时间"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd hh:mm'">{{ form.main.createTime }}</span>
          </div>
          <div class="weui-form-preview__item" slot="vi_reason">
            <label class="weui-form-preview__label">{{
              customLabel.vi_reason || "来访事由"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.vi_reason
            }}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.vi_text1 || '自定义字段1'" v-model="form.main.vi_text1"
            slot="vi_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.vi_text2 || '自定义字段2'" v-model="form.main.vi_text2"
            slot="vi_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.vi_text3 || '自定义字段3'" v-model="form.main.vi_text3"
            slot="vi_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.vi_text4 || '自定义字段4'" v-model="form.main.vi_text4"
            slot="vi_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.vi_text5 || '自定义字段5'" v-model="form.main.vi_text5"
            slot="vi_text5" hidden="true" />
        </custom-layout>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">回复状态</label>
            <span class="weui-form-preview__value">{{ form.main.status }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.vi_reply_time">
            <label class="weui-form-preview__label">回复时间</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd hh:mm'">{{ form.main.vi_reply_time }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.vi_reply_reason">
            <label class="weui-form-preview__label">拒绝理由</label>
            <span class="weui-form-preview__value">{{
              form.main.vi_reply_reason
            }}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview" v-show="form.main.vi_context">
        <div class="weui-panel__hd">来访纪要</div>
        <div class="weui-form-preview__bd">
          <div class="form-preview__html" v-html="form.main.vi_context"></div>
        </div>
      </div>
    </div>

    <div class="js_dialog" v-if="showRejectDialog">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__bd">
          <textarea class="weui-textarea" placeholder="请输入您的理由" rows="2" v-model="comment" autofocus></textarea>
        </div>
        <div class="weui-dialog__ft">
          <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_default"
            @click="showRejectDialog = false">取消</a>
          <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_primary" @click="onReject">确定</a>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="executable">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="onAccept">同意</a>
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_default" @click="showRejectDialog = true">驳回</a>
    </div>
  </div>
</template>

<script>
import form from "@/mixins/form.js";
import Auth from "@/util/auth.js";
import CallMobile from "@/components/button/CallMobile.vue";
import CustomLayout from "@/components/layout/CustomLayout.vue";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [form],
  components: {
    CallMobile,
    CustomLayout,
    CustomField
  },
  data() {
    return {
      baseUrl: "/api/oa/visit_inner",
      caller: 'VisitInner',
      xtype: 'oa-visitinner-formpanel',
      executable: false,
      showRejectDialog: false,
      comment: null,
      form: {
        main: {
          vi_status: 0
        }
      }
    };
  },
  methods: {
    f_afterload(form) {
      const me = this;
      if (form.main.vi_status > 0) {
        return;
      }
      Auth.get().then(function (data) {
        var account = data.account;
        if (account && account.id == form.main.vi_obj_acid) {
          me.executable = true;
        }
      });
    },
    reply(params) {
      const me = this;
      params.id = me.form.main.id;
      me.$loading({
        url: me.baseUrl + "/reply",
        method: 'POST',
        jsonData: params,
      }).then(function (res) {
        if (res.success) {
          me.$weui.toast("回复成功", 2000);
          window.location.reload();
        } else {
          me.$weui.topTips(res.message, 3000);
        }
      });
    },
    onAccept() {
      this.reply({
        vi_status: 1,
      });
    },
    onReject() {
      var me = this,
        comment = me.comment;
      if (!comment) {
        me.$weui.topTips("请填写驳回的原因", 3000);
      } else {
        me.showRejectDialog = false;
        me.reply({
          vi_status: 2,
          vi_reply_reason: comment,
        });
      }
    },
  },
};
</script>